/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Fade from 'react-reveal/Fade';
import Header from 'parts/Header';
import Solutions from 'parts/Solutions';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';

import Data from 'json/landingPage.json';

export default class SolutionsPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { codalienAI } = Data;

    if (!codalienAI) {
      return (
        <>
          <Header {...this.props} />
          <section className="pt-32 pb-16">
            <Solutions data={Data.solutions} />
          </section>
          <Discuss {...this.props} />
          <Footer />
        </>
      );
    }

    return (
      <>
        <Header {...this.props} />
        <section className="pt-32 pb-16">
          <Solutions data={Data.solutions} />
        </section>

        {/* ERapid AI Section */}
        <section className="bg-gray-50 py-24">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h2 className="text-4xl lg:text-5xl text-theme-blue text-center font-bold mb-4">
                {codalienAI.title}
              </h2>
            </Fade>

            {/* Specialized LLM */}
            <Fade bottom delay={200}>
              <div className="mt-16 mb-12">
                <h3 className="text-2xl font-bold text-theme-blue mb-8 text-center">
                  {codalienAI.specializedLLM.title}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {codalienAI.specializedLLM.features.map((feature) => (
                    <div key={feature.title} className="bg-white rounded-xl shadow-md border border-gray-100 p-6 transform transition-all duration-300 hover:shadow-xl hover:scale-105">
                      <h4 className="text-lg font-semibold text-theme-blue mb-2">{feature.title}</h4>
                      <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Fade>

            {/* Multi-Channel Capabilities */}
            <Fade bottom delay={300}>
              <div className="mt-16 mb-12">
                <h3 className="text-2xl font-bold text-theme-blue mb-8 text-center">
                  {codalienAI.multiChannel.title}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {codalienAI.multiChannel.features.map((feature) => (
                    <div key={feature.title} className="bg-white rounded-xl shadow-md border border-gray-100 p-6 transform transition-all duration-300 hover:shadow-xl hover:scale-105">
                      <h4 className="text-lg font-semibold text-theme-blue mb-2">{feature.title}</h4>
                      <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Fade>

            {/* Advanced Configurable Core */}
            <Fade bottom delay={400}>
              <div className="mt-16 mb-12">
                <h3 className="text-2xl font-bold text-theme-blue mb-8 text-center">
                  {codalienAI.advancedCore.title}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {codalienAI.advancedCore.features.map((feature) => (
                    <div key={feature.title} className="bg-white rounded-xl shadow-md border border-gray-100 p-6 transform transition-all duration-300 hover:shadow-xl hover:scale-105">
                      <h4 className="text-lg font-semibold text-theme-blue mb-2">{feature.title}</h4>
                      <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Fade>

            {/* Low-Cost Deployments */}
            <Fade bottom delay={500}>
              <div className="mt-16">
                <h3 className="text-2xl font-bold text-theme-blue mb-8 text-center">
                  {codalienAI.lowCostDeployments.title}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                  {codalienAI.lowCostDeployments.options.map((option) => (
                    <div key={option.title} className="bg-white rounded-xl shadow-md border border-gray-100 p-6 transform transition-all duration-300 hover:shadow-xl hover:scale-105">
                      <h4 className="text-lg font-semibold text-theme-blue mb-2">{option.title}</h4>
                      <p className="text-sm text-gray-600 leading-relaxed">{option.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Fade>
          </div>
        </section>

        <Discuss {...this.props} />
        <Footer />
      </>
    );
  }
}
